export default __webpack_public_path__ + "static/media/GHSI Annual Performance Assessment Guidelines.489326c5.pdf";